import { MIN_ORDER_COST_USDT } from "../constants";
import { formatUsd } from "./format";

export const WAGER_ERROR = { min: "min", insufficient: "insufficient" };

/** Returns the wager error kind or null. The minimum wins over the balance. */
export const getWagerError = (wager, availableBalance) => {
  if (wager < MIN_ORDER_COST_USDT) return WAGER_ERROR.min;
  if (wager > availableBalance) return WAGER_ERROR.insufficient;

  return null;
};

export const getWagerErrorText = (error, __) => {
  if (error === WAGER_ERROR.min) {
    return __("futures.validation.wager_min").replace(
      "{min}",
      formatUsd(MIN_ORDER_COST_USDT),
    );
  }

  if (error === WAGER_ERROR.insufficient) {
    return __("futures.validation.insufficient_balance");
  }

  return "";
};
